import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'gkk3JS',
    defaultMessage: 'AI Rule Creator',
    description: 'Title for the AI automation rule creator section',
  },
  description: {
    id: 'As0ayh',
    defaultMessage: 'Describe what you want to automate and AI will draft a rule for you.',
    description: 'Description explaining how to use the AI rule creator',
  },
  exampleRule: {
    id: 'PKXsQc',
    defaultMessage: 'For example, "Use UPS Ground for domestic orders over $50"',
    description: 'Example rule to show users what kind of automation they can create',
  },
  howToUse: {
    id: '8O3PYW',
    defaultMessage: 'How to Use',
    description: 'Hover text to show instructions tooltip',
  },
  safetyTip: {
    id: 'uV5tmI',
    defaultMessage: 'AI can make mistakes - please review the generated rule before saving.',
    description: 'Safety warning about AI-generated content',
  },
  generate: {
    id: 'HTFI4I',
    defaultMessage: 'Generate Rule',
    description: 'Button text to generate an automation rule',
  },
  generating: {
    id: 'T0UkMt',
    defaultMessage: 'Generating',
    description: 'Button text when generating a rule',
  },
  draftRule: {
    id: 'x9/WK2',
    defaultMessage: 'Draft Rule',
    description: 'Button text to draft an automation rule using AI',
  },
  placeholder: {
    id: 'zMNm+5',
    defaultMessage: 'Describe your automation rule...',
    description: 'Placeholder text for the AI rule input field',
  },
  combine: {
    id: 'XQ2lxu',
    defaultMessage: 'Combine',
    description: 'Initial button text to expand the AI rule creator',
  },
  invalidRequest: {
    id: '8N6Cm4',
    defaultMessage: "Can't generate an automation rule, please change your request and try again.",
    description: 'Error message when AI fails to generate a rule',
  },
  tooManyRequests: {
    id: 'OC+Stn',
    defaultMessage: 'Too many requests. Please wait a moment and try again.',
    description: 'Error message when user is rate limited',
  },
  authenticationIssue: {
    id: '+B1eIU',
    defaultMessage: 'Authentication error. Please refresh the page and try again.',
    description: 'Error message when there is an authentication issue',
  },
  noResponse: {
    id: '6ameC2',
    defaultMessage: 'Network error: Unable to reach the automation rule service. Please check your connection and try again.',
    description: 'Error message when there is no response from the AI service',
  },
  unhandledError: {
    id: 'IRyUck',
    defaultMessage: 'Something went wrong. Please try again with a different automation rule request.',
    description: 'Error message for unhandled errors',
  },
  generatingFromShippy: {
    id: 'R7Ii82',
    defaultMessage: 'Generating rule from Ask ShipStation...',
    description: 'Banner text shown when AI rule creator is auto-generating from Ask ShipStation assistant',
  },
});
